import { createValidate } from 'typia'
import { validateGuard } from 'components/shared/parsing/parsing.js'
import type { PdpProduct } from 'components/discovery/pdp/typing/pdp-product.js'


export interface ProductOption {
  id: number
  type: 'service' | 'goods' | 'goods_as_part_of_main_product'
  name: string
  product_data: Partial<PdpProduct>
  price: number
  price_formatted: string
  quantity: number | null
  selected: boolean
}

const productOptionsValidator = createValidate<ProductOption[]>()

export const parseProductOptions = (data: unknown): ProductOption[] => {
  validateGuard(productOptionsValidator, data, 'ProductOptions')

  return data
}
